import React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { InnerContainer, Root, TextBold, TextRed } from "./footer.style";
import clsx from "clsx";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";

export const OcFooter = () => {
  const isMobile = useOcIsMobile();
  const { t } = useTranslation();

  let thisYear = new Date().getFullYear().toString();

  return (
    <Root id="oc-private-layout-footer">
      <InnerContainer isMobile={isMobile}>
        <Box padding="0px 32px" textAlign={isMobile ? "center" : "unset"}>
          <TextBold>Copyright &copy; {thisYear}</TextBold>
          <Box
            component="span"
            style={{
              textDecoration: "none",
              color: "#CC0033",
            }}
          >
            <TextBold className={clsx(TextBold, TextRed)}>
              {t("MY_HR_ORGWARE_COMPANY_NAME")}
            </TextBold>
          </Box>
          <span
            style={{
              marginRight: "6px",
              fontWeight: 400,
              fontSize: "14px",
            }}
          >
            {t("MY_HR_TEXT_COPYRIGHT")}
          </span>
        </Box>
        {isMobile && <Box height="16px" />}
        <Box paddingRight="20px" height="20px">
          <img alt="orgware-logo" src="/img/owLogoFooter.png"></img>
        </Box>
      </InnerContainer>
    </Root>
  );
};

export default OcFooter;
